import { useContext, useEffect } from "react";
import { ToolContext } from "../../../../context/ToolContext";
import { JoyrideWrapper } from "../JoyrideWrapper";

export const BranchProductReportWalkthrough = ({ pathname, end, start}) => {

    const {personalization_state} = useContext(ToolContext)
    const {walkthrough} = personalization_state

    const startTour = () =>{
        walkthrough.set((prev) => ({...prev, branchProductReport:true}))
    }

    const endTour = ()=>{
        walkthrough.set((prev) => ({...prev, branchProductReport:false}))
    }

    useEffect(() => {
        start("reports", "branch-product-report", startTour)
        //eslint-disable-next-line
    }, []);

    const steps =[
            {
                content: "Select the branch that you want to generate",
                placement: "right",
                target: "#walkthrough-branch-product-report-step-1",
                disableBeacon: true
            },
            {
                content: "Select the product",
                placement: "right",
                target: "#walkthrough-branch-product-report-step-2",
                disableBeacon: true
            },
            {
                content: "Select date from",
                placement: "right",
                target: "#walkthrough-branch-product-report-step-3",
                disableBeacon: true
            },
            {
                content: "Select date to",
                placement: "right",
                target: "#walkthrough-branch-product-report-step-4",
                disableBeacon: true
            },
            {
                content: "Click Generate",
                placement: "right",
                target: "#walkthrough-branch-product-report-step-5",
                disableBeacon: true
            },
        ]

    return (
        <JoyrideWrapper 
            run={walkthrough.data.branchProductReport && window.location.pathname === pathname} 
            steps={steps} 
            setter={endTour} 
            end={end}
            p_name="branch-product-report" 
            featureName="reports"
        />
    );
}
